import { render, staticRenderFns } from "./PostalCode.vue?vue&type=template&id=b081df16&"
import script from "./PostalCode.vue?vue&type=script&lang=ts&"
export * from "./PostalCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports